import { useTranslation } from "react-i18next";
import { Box, Theme, Typography, makeStyles } from "@material-ui/core";
import { green, orange } from "@material-ui/core/colors";
import CheckIcon from "@material-ui/icons/Check";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { Office365Gateway } from "../types";

interface StatusProps {
  gateway: Office365Gateway;
}

export const InstalledStatus = ({ gateway }: StatusProps) => {
  const { t } = useTranslation("gateway");
  const classes = useStyles({ gateway });
  const StatusIcon = gateway.enabled ? CheckIcon : ErrorOutlineIcon;
  const status = gateway.enabled
    ? t("O365Gateway.enabled")
    : t("O365Gateway.disabled");

  const directions = gateway.direction.filter(
    c => !gateway.direction.some(d => d === `${c}Loopback`)
  );
  const connectorLabels = directions
    .map(c => t(`flow.option.${c[0].toLowerCase() + c.slice(1)}.title`))
    .join(", ");

  const configuredAt =
    gateway.operation?.status === "completed"
      ? new Date(gateway.operation.updatedAt).toLocaleDateString()
      : null;

  return (
    <div>
      <Typography
        component="div"
        className={classes.text}
        data-testid="installed-status"
      >
        <StatusIcon className={classes.icon} />
        <Box display="flex" flexDirection="column">
          <div>{connectorLabels}</div>
          <div>{status}</div>
          {configuredAt && (
            <Box mt="5px">
              <Typography variant="caption" color="textSecondary">
                {t("O365Gateway.lastConfigured", {
                    date: configuredAt,
                    interpolation: { escapeValue: false },
                  })}
              </Typography>
            </Box>
          )}
        </Box>
      </Typography>
    </div>
  );
};

const useStyles = makeStyles<Theme, StatusProps>({
  text: {
    display: "flex",
    gap: "5px",
    color: props => (props.gateway.enabled ? green[400] : orange[300]),
    fontSize: ".9rem",
    fontWeight: 500,
  },
  icon: { fontSize: "17", position: "relative" },
});
